import React, { useState } from 'react';
import { debounce } from 'lodash';

import './index.scss';

function TableRowsAndColumnsCountInput(props) {

  const [rootState, setRootState] = useState({
    values: props.values
  });

  const rowsCountChangeHandler = debounce(props.onRowsCountChange, 50);
  const columnsCountChangeHandler = debounce(props.onColumnsCountChange, 50);

  function handleWidthValueChange(value, index) {

    const newValues = [...rootState.values];

    newValues[index] = value;

    const newValueObject = {
      rowsCount: newValues[0],
      columnsCount: newValues[1]
    };

    const _value = +value;

    if (_value >= 1) {
      if (index === 0) {
        rowsCountChangeHandler(_value);
      } else {
        columnsCountChangeHandler(_value);
      }
    }

    setRootState({
      ...rootState,
      values: [...newValues]
    });

  }

  function renderValueControl(index) {

    const value = rootState.values[index];
    const valueControlProperties = {
      type: 'text',
      value,
      onChange(event) {
        handleWidthValueChange(event.target.value, index);
      }
    };

    return <input {...valueControlProperties} />;

  }

  function renderValueControlSection(index, label) {

    return <div className="side-value-control-section">

      {renderValueControl(index)}

      <label className="side-value-control-label field-label">{label}</label>

    </div>;

  }

  function renderMain() {

    const mainAttributes = {
      className: 'rows-and-columns-count-input-main'
    };

    return <div {...mainAttributes}>

      <div className="rows-and-columns-count-input-controls">

        {renderValueControlSection(0, 'ROWS')}
        {renderValueControlSection(1, 'COLUMNS')}

      </div>

    </div>;

  }

  return renderMain();

}

export default TableRowsAndColumnsCountInput;